// Helpers de auth — leen y limpian el JWT recibido desde Framer.
//
// Patrón Sprint 0: Framer (redsolarviva.com) llama a clerk.session.getToken({ template: "mmsor" })
// y abre mmsor.redsolarviva.com#token=<jwt>. El cliente lee el fragmento, lo borra de la URL
// inmediatamente, y lo guarda solo en memoria + sessionStorage (NO localStorage).

import type { AuthClaims } from "@domo/shared"

export const TOKEN_FRAGMENT_KEY = "token"
export const TOKEN_STORAGE_KEY = "mmsor:token"

export function readTokenFromFragment(): string | null {
    if (typeof window === "undefined") return null
    const hash = window.location.hash.replace(/^#/, "")
    if (!hash) return null
    const params = new URLSearchParams(hash)
    return params.get(TOKEN_FRAGMENT_KEY)
}

export function clearTokenFromFragment(): void {
    if (typeof window === "undefined") return
    const url = window.location.pathname + window.location.search
    window.history.replaceState(null, "", url)
}

// Decode UNSAFE — solo para hidratar UI. La verdad la valida el server.
export function decodeJwtClaimsUnsafe(
    token: string
): Partial<AuthClaims> | null {
    try {
        const parts = token.split(".")
        if (parts.length < 2) return null
        const payload = parts[1]
        const padded = payload.replace(/-/g, "+").replace(/_/g, "/")
        // atob no maneja unicode bien — usar TextDecoder.
        const binary = atob(padded)
        const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0))
        const json = new TextDecoder("utf-8").decode(bytes)
        const data = JSON.parse(json) as Record<string, unknown>
        return {
            sub: typeof data.sub === "string" ? data.sub : undefined,
            email: typeof data.email === "string" ? data.email : undefined,
            displayName:
                (typeof data.displayName === "string" && data.displayName) ||
                (typeof data.name === "string" && data.name) ||
                undefined,
            avatarUrl:
                (typeof data.avatarUrl === "string" && data.avatarUrl) ||
                (typeof data.picture === "string" && data.picture) ||
                undefined,
            isMember:
                typeof data.isMember === "boolean" ? data.isMember : undefined,
            siliconIndex:
                typeof data.siliconIndex === "number"
                    ? data.siliconIndex
                    : undefined,
        }
    } catch {
        return null
    }
}

// Devuelve un dev-token formateado para verifyClerkToken cuando el server corre sin Clerk.
export function makeDevToken(displayName: string): string {
    const id = crypto.randomUUID()
    return `dev:${id}:${displayName}`
}
